<template>
    <header class="header-area">
        
      <div class="header-top black-bg">
          <div class="container">
              <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12 pb-2">
                      <div class="welcome-area">
                          <p>Reach us on
														
							<i class="fa fa-envelope mx-2"></i>   
							<a class="text-light" href="mailto:info@ticketmojo.co.ke">info@ticketmojo.co.ke</a>
                          </p>
                      </div>
                  </div>
                   <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="header-social mt-2 ml-4 text-center">
                            <ul>
                                <li><a href="https://twitter.com/ticketmojoke"><i class="ion-social-twitter ic-social"></i></a></li>
                                <li><a href="https://instagram.com/ticketmojokenya"><i class="ion-social-instagram-outline ic-social"></i></a></li>
                            </ul>
                        </div>
                    </div>
              </div>
          </div>
      </div>

			<div class="header-middle py-1">
				<div class="container">
						<div class="row">
								<div class="col-lg-3 col-md-4 col-12 col-sm-4">
									<div class="row">
										<div class="col-6">
											<div class="logo mb-0 text-left">
												<router-link to="/">
														<img alt="Main Logo" class="py-2 " src="../assets/img/logo/logo.svg" height="50px">
												</router-link>
										</div>
										</div>

										<div class="mobile-menu col-6" style="display: none">
											<div class="text-right">
												<i class="fa fa-bars fa-lg text-white mt-3 pt-1" @click="showModal" v-if="!sidebar"></i>
												<i class="fa fa-times fa-lg text-white mt-3 pt-1" @click="hideModal" v-if="sidebar"></i>
											</div>
										</div>
									</div>										
								</div>

									<div class="account-cart col-lg-9 col-md-8 col-12 col-sm-8 py-2">
											<div class="header-middle-right f-right">
												<template v-if="userData == null">
															<div class="header-wishlist mr-4">
																	<router-link to="/login">
																			<div class="header-icon-style">
																					<i class="icon-user icons text-red"></i>
																			</div>
																			<div class="login-text-content">
																					<p class="text-light">Register <br> or <span>Sign in</span></p>
																			</div>
																	</router-link>
															</div>
													</template>

													<template v-else>
															<div class="header-cart mr-4"> 
																	<a> 
																			<div class="login-text-content ml-4">
																					<p class="text-light">{{userData.user.name}}<br>
																							<span>Account</span>
																					</p>                                           
																			</div> 

																			<b-dropdown class="dropdown">
																					<b-dropdown-item to="/tickets">My tickets</b-dropdown-item>
																					<b-dropdown-item to="/logout">Logout</b-dropdown-item>
																			</b-dropdown>
																	</a>
															</div>
													</template>
													
													<div class="header-wishlist mr-4">
														<router-link to="/start-selling">
																<div class="header-icon-style">
																	<i class="fa fa-angle-double-up text-red"></i>
																</div>
																<div class="login-text-content">
																		<p class="text-light">Sell <br> <span>With Us</span></p>
																</div>
														</router-link>
												</div>
											</div>
									</div>
						</div>
					</div>
			</div>

			<div class="mobile-sidebar"><hr class="m-0 gray-border" />
					<b-sidebar ref="mySidebar" shadow v-model="sidebar" no-close-on-esc no-close-on-backdrop no-header> 
						<div class="px-3 py-2 dark-bg">
							<router-link class="golden-btn-menu mt-2 mb-3 btn-block rounded" to="/start-selling">
								<span class="btn_text text-white">Add your event</span>						
							</router-link>
							<router-link class="golden-btn-menu mb-2 btn-block rounded" to="/login">
								<span class="btn_text text-white">Register/Login</span>						
							</router-link>
						</div>
					</b-sidebar>
				</div>
    </header>
</template>

<script>
    import { mapState} from 'vuex'

    export default {
        name: 'Header',
        computed: {
            ...mapState("auth", ["userData"]),
        },
        data () {
					return {
							sidebar: false,
							logoutLoader: false,
							mobileNav: false,
					}
        },
        methods: {
            showModal() {
                this.sidebar = true
            }, 

						hideModal() {
                this.sidebar = false
            }, 
						
						showNav() {
							this.mobileNav = true
						},

						hideNav() {
							this.mobileNav = false
						}
        }
    }
    
</script>